<template>
  <v-card flat >
    <v-card-text class="pa-2">
      <v-row dense>
        <template v-if="!isOriginSalon">
        <v-col cols="6" >
          <card-button
              dense
              :selected="isTakeAway"
              :title="$t('delivery.mode.takeAway')"
              icon="store"
              @click="takeAway"
          ></card-button>
        </v-col>

        <v-col cols="6"  >
          <card-button
              dense
              :selected="isDelivery"
              :title="$t('delivery.mode.delivery')"
              icon="delivery_dining"
              @click="delivery"
          ></card-button>
        </v-col>
        </template>

        <template v-else>

          <v-col cols="12">
            <v-text-field v-model="table" label="Mesa salón" outlined></v-text-field>
          </v-col>
        </template>

      </v-row>
    </v-card-text>

    <v-card-text class="px-2 py-0">
      <bar-order-mode-take-away v-if="isTakeAway"></bar-order-mode-take-away>
      <bar-order-mode-delivery v-if="isDelivery"></bar-order-mode-delivery>
      <bar-order-mode-salon v-if="isSalon"></bar-order-mode-salon>
    </v-card-text>

  </v-card>
</template>

<script>

import CardButton from "@/modules/delivery/components/CardButton/CardButton.vue";
import {DELIVERY, TAKE_AWAY, SALON} from "@/modules/delivery/constants/OrderDelivery";
import BarOrderModeTakeAway
  from "@/modules/delivery/components-core/business/BarOrderModeTakeAway/BarOrderModeTakeAway.vue";
import BarOrderModeSalon from "../BarOrderModeSalon/BarOrderModeSalon.vue";
import BarOrderModeDelivery
  from "@/modules/delivery/components-core/business/BarOrderModeDelivery/BarOrderModeDelivery.vue";

export default {
  name: "BarOrderMode",
  components: {
    BarOrderModeDelivery,
    BarOrderModeTakeAway, CardButton, BarOrderModeSalon
  },
  computed: {
    isTakeAway() {
      return this.$store.getters.orderSystem.order.isTakeAway
    },
    isDelivery() {
      return this.$store.getters.orderSystem.order.isDelivery
    },
    isSalon() {
      return this.$store.getters.orderSystem.order.isSalon
    },
    isOriginSalon(){
      return this.$store.getters.orderSystem.order.origin == SALON
    },
    table:{
      get(){
        return this.$store.getters.orderSystem.order.delivery.table;
      },
      set(value){
        this.$store.commit('orderTable', value)
      }
    }
  },
  mounted() {
    if(this.isOriginSalon){
       this.salon()
    }
  },
  methods: {
    takeAway() {
      this.$store.commit('orderDeliveryMode', TAKE_AWAY)
    },
    delivery() {
      this.$store.commit('orderDeliveryMode', DELIVERY)
    },
    salon() {
      this.$store.commit('orderDeliveryMode', SALON)
    },
  }
}
</script>

<style scoped>

</style>
